// 左侧目录
let config = {}
let home = [{
	'cn_name': '提报概况',
	'name': 'mation',
	'path': '/mation',
	'children': [{
		'cn_name': '概况一览',
		'name': 'overview',
		'path': '/mation/overview'
	}]
},
{
	'cn_name': '商品中心',
	'name': 'goods',
	'path': '/goods',
	'children': [{
		'cn_name': '添加单品',
		'name': 'subsomeone',
		'path': '/goods/subsomeone'
	},
	{
		'cn_name': '单品列表',
		'name': 'singleproduct',
		'path': '/goods/singleproduct',
		'children': [{
			'cn_name': '查看详情',
			'name': 'detail',
			'path': '/goods/singleproduct/detail'
		}]
	}

	]
}
];
let isvip = [{
	'cn_name': '提报概况',
	'name': 'mation',
	'path': '/mation',
	'children': [{
		'cn_name': '概况一览',
		'name': 'overview',
		'path': '/mation/overview'
	}]
}];
let myinfo = [
	{
		'cn_name': '用户中心',
		'name': 'my',
		'path': '/my',
		'icon': 'el-icon-user-solid',
		'type':'[1,3,4,5,6,7]',
		'children': [{
			'cn_name': '账号管理',
			'name': 'myinfo',
			'path': '/my/myinfo',
			'type':'[1,3,4,5,6]',
		},
		{
			'cn_name': '淘宝PID设置',
			'name': 'mypid',
			'path': '/my/mypid',
			'type':'[1,4]',
		},
		{
			'cn_name': '京东PID设置',
			'name': 'myjdpid',
			'path': '/my/myjdpid',
			'type':'[1,4]',
		},
		{
			'cn_name': '开放平台APPKEY',
			'name': 'api',
			'path': '/my/api',
			'type':'[1,4,5]',
		},
		{
			'cn_name': '商家交易管理',
			'name': 'transaction',
			'path': '/my/transaction',
			'type':'[6]',
		},
		{
			'cn_name': '带货日历',
			'name': 'usercalendar',
			'path': '/my/usercalendar',
			'type':'[7]',
			'children': [
				{
					'cn_name': '达人带货详情',
					'name': 'usercalendarinfo',
					'path': '/my/usercalendar/usercalendarinfo',
					'type':'[7]',
				}
			]
		},
		{
			'cn_name': '商单列表',
			'name': 'orderlist',
			'path': '/my/orderlist',
			'type':'[7]',
			'children': [
				{
					'cn_name': '查看商品',
					'name': 'partner_info',
					'path': '/my/orderlist/partner_info',
					'type':'[7]',
				}
			]
		},
		{
			'cn_name': '商单任务',
			'name': 'ordertask',
			'path': '/my/ordertask',
			'type':'[7]',
			'children': [
				{
					'cn_name': '商单详情',
					'name': 'ordertaskdetail',
					'path': '/my/ordertask/ordertaskdetail',
					'type':'[7]',
				}
			]
		},
		{
			'cn_name': '带货任务',
			'name': 'loadtask',
			'path': '/my/loadtask',
			'type':'[7]',
			'children': [
				{
					'cn_name': '查看详情',
					'name': 'loaddetail',
					'path': '/my/loadtask/loaddetail',
					'type':'[7]',
				}
			]
		},
		{
			'cn_name': '推广商品',
			'name': 'cooperativegoods',
			'path': '/my/cooperativegoods',
			'type':'[7]',
			'children': [
				{
					'cn_name': '商品合作历史',
					'name': 'cooperativehistory',
					'path': '/my/cooperativegoods/cooperativehistory',
					'type':'[7]',
					'children': [
						{
							'cn_name': '商单详情',
							'name': 'cooperativedetail',
							'path': '/my/cooperativegoods/cooperativehistory/cooperativedetail',
							'type':'[7]',
						}
					]
				}
			]
		}
		]
	},
	{
		'cn_name': '商家推广投放',
		'name': 'cooperation',
		'path': '/cooperation',
		'icon': 'el-icon-menu',
		'type':'[6]',
		'children': [
			{
				'cn_name': '推广商品',
				'name': 'launchgoods',
				'path': '/cooperation/launchgoods',
				'type':'[6]',

			},
			{
				'cn_name': '带货日历',
				'name': 'mycalendar',
				'path': '/cooperation/mycalendar',
				'type':'[6]',
			},
			{
				'cn_name': '投放合作',
				'name': 'cooperation',
				'path': '/cooperation/cooperation',
				'type':'[6]',
			}
		]
	}


];
let cpx = [{
	'cn_name': '合作项目',
	'name': 'cpx',
	'path': '/cpx',
	'children': [{
		'cn_name': '未进行合作',
		'name': 'cpxprogress',
		'path': '/cpx/cpxprogress'
	},
	{
		'cn_name': '进行中合作',
		'name': 'cpxruning',
		'path': '/cpx/cpxruning'
	},
	{
		'cn_name': '已完成合作',
		'name': 'cpxend',
		'path': '/cpx/cpxend'
	}
	]
}];
config.home = home;
config.isvip = isvip;
config.myinfo = myinfo;
config.cpx = cpx;
export default config;